"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkify = exports.isUrlValid = exports.ipAddressRegex = exports.urlWithUserPassword = exports.urlRegex = exports.mailToRegex = exports.splitLinks = void 0;
const linkify_it_1 = __importDefault(require("linkify-it"));
const tlds_1 = require("./tlds");
/**
 * Splits a string of links into an array of links. If the string contains no links, it splits it by spaces, commas, semicolons, and apostrophes.
 * @param linksString - The string of links to split.
 * @returns An array of links.
 */
function splitLinks(linksString) {
    if (!linksString)
        return [];
    const LINK_SPLIT_REGEX = /[,;'| ]+/;
    const linkify = (0, linkify_it_1.default)();
    const allLinks = [];
    let lastIdx = 0;
    const links = linkify.match(linksString);
    if (!links || links.length === 0) {
        return linksString.split(LINK_SPLIT_REGEX).filter(Boolean);
    }
    links.forEach((link, idx) => {
        const precedingText = linksString.slice(lastIdx, link.index);
        if (precedingText) {
            allLinks.push(...precedingText.split(LINK_SPLIT_REGEX));
        }
        const trimmedLink = trimPunctuation(link.text);
        allLinks.push(trimmedLink);
        lastIdx = link.lastIndex;
        if (idx === links.length - 1) {
            const trailingText = linksString.slice(lastIdx);
            if (trailingText) {
                allLinks.push(...trailingText.split(LINK_SPLIT_REGEX));
            }
        }
    });
    function trimPunctuation(str) {
        return str.replace(/[ ,;'|"]+$/, "");
    }
    return allLinks.filter(Boolean);
}
exports.splitLinks = splitLinks;
/** Regex to match mailto links and email addresses
 * ^                                     Match the start of the string
 *   (?:
 *       (?:https?|ftp):\/\/             Start of the protocol section, matching http, https or ftp followed by '://'
 *   )?                                  Make the protocol section optional
 *   (?:
 *       (?:[a-zA-Z0-9_-]+\.)*           Match the subdomain section that can include letters, digits, hyphens and underscores, followed by a dot
 *       [a-zA-Z0-9_-]+                  Match the domain name which can include letters, digits, hyphens, and underscores
 *   )
 *   (?:\.(?:[a-zA-Z]{2,}))              Match the top-level domain part, which consists of at least two letters
 *   (?:\/\S*)?                          Match the path part which starts with a forward slash and can contain any non-whitespace character
 * $                                     Match the end of the string
 * Additionally, the regex ensures that the string does not contain any invalid characters such as [ ] { } | \ ” % ~ # < >.
 */
exports.mailToRegex = `^(?:(?:mailto):)?[^()\\[\\].,;:s@"'_][\\w+.-]+@[A-Za-z0-9+.]+\\.[A-Za-z\\d+]+$`;
/** Regex to match http(s)|ftp links
 * ^                                     Match the start of the string
 *   (?:(?:https?|ftp):\/\/)?            Optional protocol (http, https or ftp)
 *   (?:(?:[a-zA-Z0-9_-]+\.)*            Optional subdomains (example: www.)
 *   [a-zA-Z0-9_-]+)                     Main domain
 *   (?:\.(?:[a-zA-Z]{2,}))              Top-level domain (TLD)
 *   (?:\/\S*)?                          Optional path (may include query parameters)
 * $                                     Match the end of the string
 */
exports.urlRegex = `^(?:(?:https?|ftp):\\/\\/)?(?:(?:[a-zA-Z0-9_-]+\\.)*[a-zA-Z0-9_-]+)(?:\\.(?:[a-zA-Z]{2,}))(?:\\/\\S*)?$`;
/** Regex to match links with user:password@...:port
 * ^                                     Start of string
 *   (?:                                 Start of non-capturing group
 *     (?:https?|ftp):\/\/               Match http(s) or ftp
 *   )?                                  End of non-capturing group, make it optional
 *   (?:                                 Start of non-capturing group
 *     (?:                               Start of non-capturing group
 *       [^\[\]{}|\\^\s`<>"%~#]          Match any character that is not in the blacklist
 *     )+                                End of non-capturing group, match one or more times
 *     @                                 Match the @ character
 *   )?                                  End of non-capturing group, make it optional
 *   (?:                                 Start of non-capturing group
 *     [a-z0-9-]+\.[a-z]{2,}             Match the domain name
 *   )                                   End of non-capturing group
 *   (?:                                 Start of non-capturing group
 *     :\d{1,5}                          Match the port number, if present
 *   )?                                  End of non-capturing group, make it optional
 *   (?:                                 Start of non-capturing group
 *     \/                                Match the forward slash character
 *     [^\[\]{}|\\^"<>%~]*               Match any character that is not in the blacklist
 *   )*                                  End of non-capturing group, match zero or more times
 *   (?:                                 Start of non-capturing group
 *     \?                                Match the question mark character
 *     [^\[\]{}|\\^"<>%~#]*              Match any character that is not in the blacklist
 *   )?                                  End of non-capturing group, make it optional
 *   (?:                                 Start of non-capturing group
 *     \#                                Match the hash character
 *     [^\[\]{}|\\^"<>%~]*               Match any character that is not in the blacklist
 *   )?                                  End of non-capturing group, make it optional
 * $
 * */
exports.urlWithUserPassword = `^(?:(?:https?|ftp):\\/\\/)(?:(?:[^\\[\\]{}|\\\\^\\s\`<>"%~#])+@)?(?:[a-z0-9-]+\\.)+[a-z]{2,}(?::\\d{1,5})?(?:\\/[^\\[\\]{}|\\\\^"<>%~]*)*(?:\\?[^\\[\\]{}|\\\\^"<>%~#]*)?(?:#[^\\[\\]{}|\\\\^"<>%~]*)?$`;
/** Regex to match IP addresses
 * ^                                    Start of the string
 *  (?:                                 Start of non-capturing group
 *    (?:https?|ftp)                    Match either http, https, or ftp
 *    :\/\/                             Match :// literally
 *  )?                                  End of non-capturing group, make it optional
 *  (?:[0-9]{1,3}\.){3}[0-9]{1,3}       Match a sequence of four numbers separated by dots, representing an IP address
 *  (?::[0-9]{1,5})?                    Match an optional port number after the IP address
 *  (?:\/\S*)?                          Match an optional path after the port number
 * $                                    Eend of the string
 */
exports.ipAddressRegex = `^(?:(?:https?|ftp):\\/\\/)?(?:[0-9]{1,3}\\.){3}[0-9]{1,3}(?::[0-9]{1,5})?(?:\\/\\S*)?$`;
/**
 * Parse links like:
 * - https://www.smartsuite.com
 * - https://smartsuite.com
 * - http://smartsuite.com
 * - smartsuite.com
 * - www.smartsuite.com
 * - smartsuite.com/abc
 * - smartsuite.com/abc?def=ghi
 * - smartsuite.com/abc?def=ghi#jkl
 * - smartsuite.com/abc?def=ghi#jkl?mno
 * - smartsuite.com/abc?
 * - mailto:mail@smartsuite.com
 * - http://userid:password@example.com:8080
 * - http://142.42.1.1/
 * - http://142.42.1.1:8000/
 */
function isUrlValid(url) {
    const linkRegexp = new RegExp(`${exports.urlRegex}|${exports.mailToRegex}|${exports.urlWithUserPassword}|${exports.ipAddressRegex}`, "i");
    return linkRegexp.test(url);
}
exports.isUrlValid = isUrlValid;
const linkify = () => {
    return (0, linkify_it_1.default)().tlds(tlds_1.tlds, true);
};
exports.linkify = linkify;
